// Modules exported here will be included in bundle.js
export function showCopiedMessageClipboard(button, copyData) {
  const clipboardData = {
    'text/html': new Blob([copyData], {type: 'text/html'}),
  };
  clipboardData['text/plain'] = new Blob([convertToPlainText(copyData)], {type: 'text/plain'});
  const clipboardItem = new ClipboardItem(clipboardData);
  navigator.clipboard.write([clipboardItem]);

  var optionText = button.getElementsByClassName("copyMenu-copy-option")[0];
  optionText.classList.add('not-visible');
  optionText.classList.remove('made-visible');
  var copiedText = button.getElementsByClassName("copyMenu-copied-message")[0];
  copiedText.classList.add('made-visible');
  setTimeout(function() {
    optionText.classList.add('made-visible');
    optionText.classList.remove('not-visible');
    copiedText.classList.remove('made-visible');
    }, 2000);
}

function convertToPlainText(html){
    let doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
}

// export function showCopiedMessageZD(button, eventType, value, title) {
//   if (eventType == 'copyResultText' || eventType == 'copyLink') {
//     navigator.clipboard.writeText(value);
//   } else {
//     var message = {"eventType": eventType, "value": value, "title": title};
//     parent.postMessage(message, "*");
//   }
 
//   var optionText = button.getElementsByClassName("copyMenu-copy-option")[0];
//   optionText.classList.add('not-visible');
//   optionText.classList.remove('made-visible');
//   var copiedText = button.getElementsByClassName("copyMenu-copied-message")[0];
//   copiedText.classList.add('made-visible');
//   setTimeout(function() { 
//     optionText.classList.add('made-visible');
//     optionText.classList.remove('not-visible');
//     copiedText.classList.remove('made-visible');
//     }, 2000);
// };


export function showCopiedMessageSF(button, eventType, card) {
  card["eventType"] = eventType;
  card["isDirectAnswer"] = false;
  card["refreshCase"] = false;
  parent.postMessage(card, "*");

  var optionText = button.getElementsByClassName("copyMenu-copy-option")[0];
  optionText.classList.add('not-visible');
  optionText.classList.remove('made-visible');
  var copiedText = button.getElementsByClassName("copyMenu-copied-message")[0];
  copiedText.classList.add('made-visible');
  setTimeout(function() { 
    optionText.classList.add('made-visible');
    optionText.classList.remove('not-visible');
    copiedText.classList.remove('made-visible');
    }, 2000);
};

export function showResultActionSF(resultAction, eventType, title, value, entityId, entityType) {	
	
  //Creates a card variable with properties eventType, isDirectAnswer, title, and value. 	
 var card = {"entityType": entityType, "eventType": eventType, "isDirectAnswer": false, "title": title, "value": value, "entityId": entityId};	
 console.log("Card object passed:", card);	
 	
  //Posts a message to the Salesforce Agent Desktop app with the entire result card variable	
 parent.postMessage(card, "*");	
  //The below code is the same as the result action function for Zendesk and Freshdesk.	
 	
  if (!resultAction) {	
      console.error('resultAction is undefined');	
      return;	
    }	
 	
  //Gets the result action option text class, makes it hidden, and sets it as a variable.	
  var optionText = resultAction.getElementsByClassName("copyMenu-copy-option")[0];	
  if (optionText) {	
    optionText.classList.add('not-visible');	
    optionText.classList.remove('made-visible');	
  } else {	
    console.error('copyMenu-copy-option element not found');	
  }
 	 
  //Gets the result action execution message class, makes it visible, and sets it as a variable.	
  var executedMessage = resultAction.getElementsByClassName("copyMenu-copied-message")[0];	
  if (executedMessage) {	
    executedMessage.classList.add('made-visible');	
  } else {	
    console.error('copyMenu-copied-message element not found');	
  }	
 	
  //Two seconds after the result action is executed, return the option text and execution message text to their original states. 	
  setTimeout(function() {	
    if (optionText) {	
      optionText.classList.add('made-visible');	
      optionText.classList.remove('not-visible');	
    }	
    if (executedMessage) {	
      executedMessage.classList.remove('made-visible');	
    }	
  }, 2000);	
};

// export function showCopiedMessageDirect(button, eventType, title, value) {
//   var card = {"eventType": eventType, "isDirectAnswer": true, "title": title, "value": value};
//   parent.postMessage(card, "*");

//   var optionText = button.getElementsByClassName("copyMenu-copy-option")[0];
//   optionText.classList.add('not-visible');
//   optionText.classList.remove('made-visible');
//   var copiedText = button.getElementsByClassName("copyMenu-copied-message")[0];
//   copiedText.classList.add('made-visible');
//   setTimeout(function() { 
//     optionText.classList.add('made-visible');
//     optionText.classList.remove('not-visible');
//     copiedText.classList.remove('made-visible');
//     }, 2000);
// };